import { useFormContext } from "react-hook-form";

import {
  selectBasicQuestions,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";
import { FormTextField } from "@covertree/ui";

import { HomeDetailsForm } from "../validatorsAndTypes/homeDetailsAndConstructionForm";

interface Props {
  name?: string;
  label?: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
  fontSize?: number;
  labelFontSize?: number;
}

export function ModelHomeInput({
  name = "modelHome",
  label = "Model",
  tooltip = "Indicate the model name for the home.",
  disabled = false,
  fontSize,
  labelFontSize,
}: Props) {
  const { modelHome } = useNewBusinessSelector(selectBasicQuestions);

  const { control, setValue } = useFormContext<HomeDetailsForm>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(
      name as keyof HomeDetailsForm,
      e.target.value === "" ? null : e.target.value,
      { shouldValidate: true }
    );
  };

  return (
    <FormTextField
      id="modelHome"
      dataTestId="model-home-input"
      name={name}
      label={modelHome?.label ?? label}
      tooltip={modelHome?.tooltip ?? tooltip}
      control={control}
      optional
      disabled={disabled}
      onChange={handleChange}
      fontSize={fontSize}
      labelFontSize={labelFontSize}
    />
  );
}
